export default __webpack_public_path__ + "static/media/home-artboard-2.9e1368f2.jpg";